import { Badge } from '@material-ui/core'
import styled from 'styled-components'

const ButtonBubble = styled(Badge)`
  .MuiBadge-badge {
    font-size: 0.6rem;
    height: 14px;
    min-width: 13px;
    border-radius: 6.5;
  }
`

export { ButtonBubble }
